export default {
  'menu.home': 'Home',
  'menu': 'TodayMall',
  'menu.todayggigu': 'TodayGgigu',
  'menu.login': 'Login',
  'menu.logout': 'Logout',
  'menu.orders': 'Orders',
  'menu.cs.suggestion': 'Platform Review',
  'menu.products.import-taobao': 'Import Taobao Link',
  'menu.products.categories': 'Category Management',
  'menu.products.stores': 'Store Management',
  'menu.products.live-sellers': 'Live Sellers',
  'menu.products.live-sellers.sellers': 'Seller List',
  'menu.products.seller-detail': 'Seller Detail',
  'menu.products.rebate-settings': 'Rebate Settings',
  'menu.products.rebate-settings.rebate-level': 'Rebate Level',
  'menu.products.rebate-settings.rebate-rules': 'Rebate Rules',
  'menu.products.coupon-point-settings': 'Point/Coupon Settings',
  'menu.cs.notices': 'Notices',
  'menu.products.search-management': 'Search Management',
  'menu.products.search-management.danger-management': 'Dangerous Terms Management',
  'menu.products.search-management.edit-search-term': 'Edit Search Term',
  'menu.operations': 'Operations',
  'menu.operations.operation-data': 'Operation Data',
  'menu.operations.list': 'CompanyMall',
  'menu.operations.add': 'Add Product',
  'menu.operations.edit': 'Edit Product',
  'menu.operations.import-taobao': 'Import Promotion Link',
  'menu.operations.categories': 'Category Management',
  'menu.operations.stores': 'Store Management',
  'menu.operations.promo-videos': 'Promo videos',
  'menu.operations.live': 'Live',
  'menu.operations.live.live-sellers': 'Live Sellers',
  'menu.operations.live.live-team-list': 'Live Team List',
  'menu.operations.live.live-rebate-settings': 'Live Rebate Settings',
  'menu.operations.live.live-page-settings': 'Live Page Settings',
  'menu.operations.live.seller-detail': 'Seller Detail',
  'menu.operations.live-sellers': 'Live Sellers',
  'menu.operations.live-team-list': 'Live Team List',
  'menu.operations.live-page-settings': 'Live Page Settings',
  'menu.operations.frontend-pages': 'Frontend Page Settings',
  'menu.operations.seller-detail': 'Seller Detail',
  'menu.operations.rebate-settings': 'Rebate Settings',
  'menu.operations.rebate-settings.rebate-level': 'Rebate Level',
  'menu.operations.rebate-settings.rebate-rules': 'Rebate Rules',
  'menu.operations.live-rebate-settings': 'Live Rebate Settings',
  'menu.operations.store-rebate-settings': 'Store Rebate Settings',
  'menu.operations.share-rebate-settings': 'Share Rebate Settings',
  'menu.operations.coupon-point-settings': 'Point/Coupon Settings',
  'menu.operations.search-management': 'Search Management',
  'menu.operations.search-management.danger-management': 'Dangerous Terms Management',
  'menu.operations.search-management.edit-search-term': 'Edit Search Term',
  'menu.orders.user': 'User Orders',
  'menu.orders.statistics': 'Order Statistics',
  'menu.orders.pending-payment': 'Payment Confirmation',
  'menu.orders.no-data': 'No Data',
  'menu.orders.questions': 'Order Inquiries',
  'menu.todayggigu.orders.tradeServices': 'Trade Services',
  'menu.todayggigu.orders.tradeServices.comprehensive': 'Comprehensive Management',
  'menu.todayggigu.orders.tradeServices.pendingPayment': 'Pending Payment',
  'menu.todayggigu.orders.paymentAgency': 'Payment Agency',
  'menu.todayggigu.orders.paymentAgency.comprehensive': 'Comprehensive Management',
  'menu.todayggigu.orders.paymentAgency.pendingPayment': 'Pending Payment',
  'menu.todayggigu.orders.paymentAgency.forexDepositApplication': 'Forex Deposit Application',
  'menu.todayggigu.orders.paymentAgency.forexDepositUsage': 'Forex Deposit Usage',
  'menu.todayggigu.orders.paymentAgency.forexDepositPayment': 'Forex Deposit Payment',
  'menu.storehouse': 'Storehouse',
  'menu.storehouse.express-inspection': 'Express Inspection',
  'menu.storehouse.non-master-courier': 'Non-Master Courier',
  'menu.storehouse.inspection-list': 'Inspection List',
  'menu.storehouse.rack': 'Rack Management',
  'menu.storehouse.inventory': 'Inventory Management',
  'menu.storehouse.inventory-detail': 'Warehouse Detail',
  'menu.storehouse.warehouse-address': 'Warehouse Address',
  'menu.storehouse.waybill-informations': 'Waybill Informations',
  'menu.storehouse.waybill-bandwidth-management': 'Waybill Bandwidth Management',
  'menu.storehouse.transportation-methods': 'Transportation Methods',
  'menu.storehouse.logistics-trajectory': 'Logistics Trajectory',
  'menu.storehouse.regional-management': 'Regional Management',
  'menu.storehouse.international-tracking-number-management': 'International Tracking Number Management',
  'menu.storehouse.hs-product-code-management': 'HS Product Code Management',
  'menu.members': 'Members',
  'menu.members.general': 'General Members',
  'menu.members.blacklist': 'Blacklist Members',
  'menu.members.statistics': 'Member Statistics',
  'menu.members.active-users': 'Active Users',
  'menu.members.membershipLevelManagement': 'Membership Level Management',
  // RebateLevel, RebateRules, FinancialRecord, Deposit moved to settlement/settings
  'menu.members.rechargeReview': 'Recharge Review',
  'menu.members.withdrawReview': 'Withdraw Review',
  'menu.members.userPromotionDetail': 'User Promotion Detail',
  'menu.members.memberDocuments': 'Member Document Management',
  'menu.members.consumptionChangeDetails': 'Consumption Change Details',
  'menu.members.coupon-point-settings': 'Coupon Point Settings',
  'menu.statistics': 'Statistics',
  'menu.statistics.visit-analytics': 'Visits & Clicks',
  'menu.settlement': 'Financial Management',
  'menu.settlement.sellers': 'Seller Settlement',
  'menu.settlement.dashboard': 'Dashboard',
  'menu.settlement.platform': 'Platform Fees',
  'menu.settlement.deposit-application-history': 'Deposit Application History',
  'menu.settlement.deposit-usage-history': 'Deposit Usage History',
  'menu.settlement.rebate-rules': 'Rebate Rules',
  'menu.settlement.rebate-levels': 'Rebate Levels',
  'menu.settlement.financial-tax-report': 'Financial Tax Report',
  'menu.settlement.financial-record': 'Financial Record',
  'menu.settlement.deposit': 'Deposit',
  'menu.settlement.pending-payment': 'Pending Payment',
  'menu.settlement.share-rebates': 'Share Rebates',
  'menu.settings': 'Settings',
  'menu.settings.rebate-level': 'Rebate Level',
  'menu.settings.rebate-rules': 'Rebate Rules',
  'menu.settings.product-price-increase': 'Product Price Increase',
  'menu.settings.service-fee': 'Service Fee',
  'menu.settings.website-content-management': 'Website Content Management',
  'menu.settings.website-content-management.seo-settings': 'Website SEO Settings',
  'menu.settings.website-content-management.email-configuration': 'Email Configuration',
  'menu.settings.website-content-management.image-settings': 'Image Settings',
  'menu.settings.website-content-management.basic-configuration': 'Website Basic Configuration',
  'menu.settings.website-content-management.app-settings': 'App Settings',
  'menu.settings.mail-management': 'Mail Management',
  'menu.settings.mail-management.email-template': 'Email Template',
  'menu.settings.mail-management.sms-template': 'SMS Template',
  'menu.settings.mail-management.email-log': 'Email Log',
  'menu.settings.mail-management.push-message': 'Push Message',
  // 'menu.settings': 'System Settings',
  'menu.settings.admins': 'Admin Accounts',
  'menu.settings.rates': 'Exchange Rate/Tariff',
  'menu.settings.purchase-condition-settings': 'Purchase Condition Settings',
  'menu.settings.additional-cost-settings': 'Additional Cost Settings',
  'menu.settings.additional-service': 'Additional Service',
  'menu.settings.shipping-rate': 'Shipping Rate',
  'menu.settings.work-log': 'Work Log',
  'menu.settings.island-mountain-cost': 'Island/Mountain Cost',
  'menu.cs': 'Customer Service',
  'menu.cs.inquiries': '1:1 Inquiries',
  'menu.cs.faq': 'FAQ',
  'menu.cs.help': 'Help Center',
  'menu.cs.banners': 'Banners/Events',
  'menu.todayggigu.cs.event': 'Event',
  'menu.list': 'List',
  'menu.add': 'Add',
  // Search Management and Mail Management moved to settings
  'menu.cs.looking-for-owner': 'Looking for Owner',
  'menu.cs.reviews': 'Reviews',
  'menu.cs.review-write': 'Write Review',
  'menu.cs.review-detail': 'Review Detail',
  'menu.cs.review-edit': 'Edit Review',
  'menu.todayggigu.orders': 'Orders',
  'menu.todayggigu.orders.business': 'Business Orders',
  'menu.todayggigu.orders.business.orders': 'Orders',
  'menu.todayggigu.orders.business.pending-payment': 'Pending Payment',
  'menu.todayggigu.orders.business.no-data': 'No Data',
  'menu.todayggigu.orders.vvic': 'VVIC Highpass Orders',
  'menu.todayggigu.orders.vvic.orders': 'Orders',
  'menu.todayggigu.orders.vvic.pending-payment': 'Pending Payment',
  'menu.todayggigu.orders.vvic.no-data': 'No Data',
  'menu.todayggigu.orders.rocket': 'Rocket Orders',
  'menu.todayggigu.orders.rocket.orders': 'Orders',
  'menu.todayggigu.orders.rocket.pending-payment': 'Pending Payment',
  'menu.todayggigu.orders.rocket.no-data': 'No Data',
  'menu.todayggigu.orders.pending-payment': 'Payment Confirmation',
  'menu.todayggigu.orders.statistics': 'Order Statistics',
  'menu.todayggigu.orders.pending-address': 'Pending Address',
  'menu.todayggigu.orders.in-china-warehouse': 'In China Warehouse',
  'menu.todayggigu.orders.in-korea-delivery': 'In Transit',
  'menu.todayggigu.orders.completed': 'Completed',
  'menu.todayggigu.orders.no-data': 'No Data',
  'menu.todayggigu.orders.questions': 'Order Inquiries',
  'menu.todayggigu.orders.inventory-questions': 'Inventory Inquiries',
  'menu.todayggigu.lowest-price-products': 'Lowest Price Products',
  'menu.todayggigu.lowest-price-products.list': 'Product List',
  'menu.todayggigu.lowest-price-products.category': 'Category Management',
  'menu.todayggigu.homepage': 'Homepage Management',
  'menu.todayggigu.homepage.main-rolling-banner': 'Main Rolling Banner',
  'menu.todayggigu.homepage.banner-management': 'Banner Management',
  'menu.todayggigu.homepage.recommended-products': 'Recommended Products',
  'menu.todayggigu.homepage.departure-schedule': 'Departure Schedule',
  'menu.todayggigu.homepage.shopping-information': 'Shopping Information',
  'menu.todayggigu.homepage.event-management': 'Event Management',
  'menu.todayggigu.homepage.popup-management': 'Popup Management',
  'menu.todayggigu.homepage.page-management': 'Page Management',
  'menu.todayggigu.homepage.mail-form-management': 'Mail Form Management',
  'menu.todayggigu.coupon-management': 'Coupon Management',
  'menu.todayggigu.coupon-management.issuance-details': 'Coupon Issuance Details',
  'menu.todayggigu.coupon-management.coupon-issuance-details': 'Coupon Issuance Details',
  'menu.todayggigu.coupon-management.event-coupon': 'Event Coupon',
  'menu.todayggigu.sms': 'SMS Management',
  'menu.todayggigu.sms.send': 'Send SMS',
  'menu.todayggigu.sms.sending-history': 'Sending History',
  'menu.todayggigu.sms.kakao-sms-management': 'Kakao SMS Management',
  'menu.todayggigu.sms.point-details': 'Point Details',
  'menu.todayggigu.environment-setting': 'Environment Setting',
  'menu.todayggigu.environment-setting.membership-level': 'Membership Level',
  'menu.todayggigu.environment-setting.administrator-management': 'Administrator Management',
  'menu.todayggigu.environment-setting.center-management': 'Center Management',
  'menu.todayggigu.environment-setting.shipping-rate': 'Shipping Rate',
  'menu.todayggigu.environment-setting.deposit-account': 'Deposit Account',
  'menu.todayggigu.environment-setting.customs-exchange-rate': 'Customs Exchange Rate',
  'menu.todayggigu.environment-setting.applicable-exchange-rate': 'Applicable Exchange Rate',
  'menu.todayggigu.environment-setting.additional-service': 'Additional Service',
  'menu.todayggigu.environment-setting.island-mountain-cost': 'Island/Mountain Cost',
  'menu.todayggigu.environment-setting.item-management': 'Item Management',
  'menu.todayggigu.environment-setting.waybill-bandwidth': 'Waybill Bandwidth',
  'menu.todayggigu.members': 'Members',
  'menu.todayggigu.members.business': 'Business Members',
  'menu.todayggigu.members.blacklist': 'Blacklist Members',
  'menu.todayggigu.members.points': 'Points',
  'menu.todayggigu.members.statistics': 'Member Statistics',
  'menu.todayggigu.members.active-users': 'Active Users',
  'menu.todayggigu.members.membershipLevelManagement': 'Membership Level Management',
  'menu.todayggigu.members.rebateLevel': 'Rebate Level',
  'menu.todayggigu.members.rebateRules': 'Rebate Rules',
  'menu.todayggigu.members.financialRecord': 'Financial Record',
  'menu.todayggigu.members.deposit': 'Deposit',
  'menu.todayggigu.members.userPromotionDetail': 'User Promotion Detail',
  'menu.todayggigu.members.consumptionChangeDetails': 'Consumption Change Details',
  'menu.todayggigu.members.coupons': 'Coupon Management',
  'menu.todayggigu.members.coupon-point-settings': 'Coupon Point Settings',
  'menu.todayggigu.members.depositApplication': 'Deposit Application Details',
  'menu.todayggigu.members.depositUsage': 'Deposit Usage Details',
  'menu.todayggigu.members.bankbookVerification': 'Automatic Verification of Bankbook',
  'menu.todayggigu.members.forexDepositApplication': 'Foreign Exchange Deposit Application Details',
  'menu.todayggigu.members.forexDepositUsage': 'Foreign Exchange Deposit Usage Details',
  'menu.todayggigu.members.forexDepositPayment': 'Foreign Exchange Deposit Payment Details',
  'menu.todayggigu.settlement': 'Financial Management',
  'menu.todayggigu.settlement.sellers': 'Seller Settlement',
  'menu.todayggigu.settlement.platform': 'Platform Fees',
  'menu.todayggigu.settings': 'Settings',
  'menu.todayggigu.settings.rebate-level': 'Rebate Level',
  'menu.todayggigu.settings.rebate-rules': 'Rebate Rules',
  'menu.todayggigu.settings.coupons': 'Point/Coupon Settings',
  'menu.todayggigu.settings.product-price-increase': 'Product Price Increase',
  'menu.todayggigu.settings.service-fee': 'Service Fee',
  'menu.todayggigu.settings.search-management': 'Search Management',
  'menu.todayggigu.settings.search-management.danger-management': 'Danger Management',
  'menu.todayggigu.settings.search-management.edit-search-term': 'Edit Search Term',
  'menu.todayggigu.bulletin-board': 'Bulletin Board Management',
  'menu.todayggigu.bulletin-board.event': 'Event',
  'menu.todayggigu.bulletin-board.settings': 'Bulletin Board Setting',
  'menu.todayggigu.bulletin-board.inquiries': '1:1 Inquiries',
  'menu.todayggigu.bulletin-board.inquiries.add': 'Add Inquiry',
  'menu.todayggigu.bulletin-board.inquiries.edit': 'Edit Inquiry',
  'menu.todayggigu.bulletin-board.notices': 'Notices',
  'menu.todayggigu.bulletin-board.notices.add': 'Add Notice',
  'menu.todayggigu.bulletin-board.notices.edit': 'Edit Notice',
  'menu.todayggigu.bulletin-board.faq': 'FAQ',
  'menu.todayggigu.bulletin-board.faq.add': 'Add FAQ',
  'menu.todayggigu.bulletin-board.faq.edit': 'Edit FAQ',
  'menu.todayggigu.bulletin-board.help': 'Help Center',
  'menu.todayggigu.bulletin-board.banners': 'Event',
  'menu.todayggigu.bulletin-board.looking-for-owner': 'Looking for Owner',
  'menu.todayggigu.bulletin-board.looking-for-owner.add': 'Add Looking for Owner',
  'menu.todayggigu.bulletin-board.looking-for-owner.edit': 'Edit Looking for Owner',
  'menu.todayggigu.bulletin-board.reviews': 'Reviews',
  'menu.todayggigu.bulletin-board.reviews.add': 'Add Review',
  'menu.todayggigu.bulletin-board.reviews.edit': 'Edit Review',
  'menu.todayggigu.bulletin-board.suggestion': 'Suggestions',
  'menu.todayggigu.bulletin-board.suggestion.add': 'Add Suggestion',
  'menu.todayggigu.bulletin-board.suggestion.edit': 'Edit Suggestion',
  'menu.todayggigu.bulletin-board.event.add': 'Add Event',
  'menu.todayggigu.bulletin-board.event.edit': 'Edit Event',
  'menu.todayggigu.bulletin-board.search-management': 'Search Management',
  'menu.todayggigu.bulletin-board.search-management.danger-management': 'Danger Word Management',
  'menu.todayggigu.bulletin-board.search-management.edit-search-term': 'Edit Search Term',
  'menu.todayggigu.bulletin-board.mail-management': 'Mail Management',
  'menu.todayggigu.bulletin-board.mail-management.email-template': 'Email Template',
  'menu.todayggigu.bulletin-board.mail-management.sms-template': 'SMS Template',
  'menu.todayggigu.bulletin-board.mail-management.email-log': 'Email Log',
  'menu.todayggigu.bulletin-board.mail-management.push-message': 'Push Message',
  'menu.todayggigu.settings.mail-management': 'Mail Management',
  'menu.todayggigu.settings.mail-management.email-template': 'Email Template',
  'menu.todayggigu.settings.mail-management.sms-template': 'SMS Template',
  'menu.todayggigu.settings.mail-management.email-log': 'Email Log',
  'menu.todayggigu.settings.mail-management.push-message': 'Push Message',
  'menu.todayggigu.settings.mail-management.website-content-management': 'Website Content Management',
  'menu.todayggigu.settings.website-content-management.seo-settings': 'Website SEO Settings',
  'menu.todayggigu.settings.website-content-management.email-configuration': 'Email Configuration',
  'menu.todayggigu.settings.website-content-management.image-settings': 'Image Settings',
  'menu.todayggigu.settings.website-content-management.basic-configuration': 'Website Basic Configuration',
  'menu.todayggigu.settings.website-content-management.app-settings': 'App Settings',
  'menu.todayggigu.settings.website-content-management': 'Website Basic Configuration',
  'menu.todayggigu.system-settings': 'System Settings',
  'menu.todayggigu.system-settings.admins': 'Admin Accounts',
  'menu.todayggigu.system-settings.rates': 'Exchange Rate/Tariff',
  'menu.todayggigu.system-settings.purchase-condition-settings': 'Purchase Condition Settings',
  'menu.todayggigu.system-settings.shipping-rate': 'Shipping Rate',
  'menu.todayggigu.system-settings.work-log': 'Work Log',
  'menu.todayggigu.bulletin-board.review-write': 'Write Review',
  'menu.todayggigu.bulletin-board.review-detail': 'Review Detail',
  'menu.todayggigu.bulletin-board.review-edit': 'Edit Review',
  'menu.todayggigu.rack': 'Rack Management',
  'menu.todayggigu.rack.management': 'Rack Management',
  'menu.todayggigu.rack.usage': 'Rack Usage Management',
  'menu.todayggigu.rack.usage-management': 'Rack Usage Management',
  'menu.todayggigu.rack.information-log': 'Rack Information Log',
  'menu.todayggigu.statistics': 'Statistics Management',
  'menu.todayggigu.statistics.order': 'Order Statistics',
  'menu.todayggigu.statistics.member': 'Member Statistics',
  'menu.todayggigu.statistics.worker': 'Worker Statistics',
  'menu.todayggigu.statistics.worker-log': 'Worker Log',
  'menu.todayggigu.statistics.tax-settlement': 'Tax Settlement',
  'menu.todayggigu.statistics.purchase-cost': 'Purchase Cost Statistics',
  'menu.todayggigu.statistics.trade-cost': 'Trade Cost Statistics',
  'menu.todayggigu.statistics.payment-agency': 'Payment Agency Statistics',
  'menu.todayggigu.solution-inquiry': 'Solution Inquiry',
  'menu.system': 'System',
  'menu.system.admins': 'Admin Accounts',
  'menu.system.roles': 'Role Management',
  'menu.system.rates': 'Exchange Rate/Tariff',
  'menu.system.purchase-condition-settings': 'Purchase Condition Settings',
  'menu.system.shipping-rate': 'Shipping Rate',
  'menu.system.work-log': 'Work Log',
  'menu.system.banners': 'Banner/Advertisement Management',
  'menu.account': 'Account',
  'menu.account.center': 'Profile',
  'menu.account.settings': 'Settings',
  'menu.account.logout': 'Logout',

  // Trade Services
  'menu.orders.tradeServices': 'Trade Services',
  'menu.orders.tradeServices.comprehensive': 'Comprehensive Management',
  'menu.orders.tradeServices.pendingPayment': 'Pending Payment',

  // Payment Agency
  'menu.orders.paymentAgency': 'Payment Agency',
  'menu.orders.paymentAgency.comprehensive': 'Comprehensive Management',
  'menu.orders.paymentAgency.pendingPayment': 'Pending Payment',
  'menu.orders.paymentAgency.forexDepositApplication': 'Forex Deposit Application',
  'menu.orders.paymentAgency.forexDepositUsage': 'Forex Deposit Usage',
  'menu.orders.paymentAgency.forexDepositPayment': 'Forex Deposit Payment',
};
